import React from "react";
import {
  Box,
  Text,
  Tooltip,
} from "@chakra-ui/react";

const ItemBox = ({ label, value }) => {
  const strLimit = 45
  const truncate = (str) => str.length > strLimit ? `${str.substring(0, strLimit)}...` : str;

  return (
    <Box borderWidth="1px" borderRadius="lg" p="2" height="10" w="400px">
      <Tooltip label={(label + ": " + value).length > strLimit ? (label + ": " + value) : ""}>
        <Text>{truncate(label + ": " + value)}</Text>
      </Tooltip>
    </Box>
  );
};

export default ItemBox;
